import { z } from "zod";

export const ValidationUpdateResponse = z.object({
    success: z.literal(false),
    message: z.literal("Validation errors"),
    code: z.literal(422),
    errors: z.object({
        password: z.array(z.string()),
        new_password: z.array(z.string()),
        confirm_new_password: z.array(z.string()),
    }),
});